export const Storage = {
    get: function (key) {
        return localStorage.getItem(`lensmark::${key}`);
    },
    set: function (key, value) {
        return localStorage.setItem(`lensmark::${key}`, value);
    }
}